import { ExtensionBase } from "./extensionBase";

/**
 * An extension that switches perspective to orthographic when loaded.
 */
export class OrthographicExtension extends ExtensionBase {

    static extensionName: string = "OrthographicExtension";

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, options: any) {
        super(viewer, options);
        this.onModelRootLoaded = this.onModelRootLoaded.bind(this);
    }

    static registerExtension() {
        super.registerExtension(OrthographicExtension.extensionName, OrthographicExtension);
    }

    protected onModelRootLoaded(): void {
        // Projection change is possible after the model has been loaded.
        // This event seems to precede viewer's onModelLoadSuccess which is good as we need to 
        // set orthographic before the camera position is set or it will change when the projection changes.
        this.viewer.navigation.toOrthographic();     
    }

    load(): boolean {
        console.log("OrthographicExtension is loaded!");
        return super.load();
    };

}